/*
 * 配送日時・ギフト欄（自作） 2026-08-29／2026-09-21 配送日の「指定なし」トグル・都道府県別の最短日を追加／2026-09-22 イベントのバブリングを止める修正
 *
 * main-cart-items.liquid 内の <cart-delivery-gift> を監視し、
 * 入力が変わるたびに Shopify のカート属性（note_attributes）へ即時保存する。
 *
 * こうしておく理由：
 * Dawnテーマのカートは数量変更のたびに main-cart-items セクションを
 * サーバー側で再描画して丸ごと差し替える（cart.js の onCartUpdate 参照）。
 * フォーム送信（チェックアウトボタン）まで保存を待つ設計だと、
 * 「日付を入力 → 数量を変える → 前の入力が消える」事故が起きるため、
 * 入力のたびに /cart/update.js へ保存しておく。
 *
 * 属性名は Ship&co が送り状印刷に使っている名前のまま。変更しないこと。
 *   shipandco-配達希望日 / shipandco-配達希望時間帯 /
 *   shipandco-ギフト / shipandco-ギフト依頼主 / shipandco-ギフトメッセージ / shipandco-熨斗 /
 *   shipandco-配送先都道府県（2026-09-21追加。最短お届け日の判定用の参考情報として保存するだけで、
 *   実際の配送先住所はチェックアウトで別途入力される。あくまで目安の案内という位置づけ）
 *
 * 【注意・実測で判明した仕様】
 * Shopify の /cart/update.js は「attributes」を送ると、送った分だけを更新するのではなく
 * カート属性を丸ごと置き換える（マージしない）。
 * 1項目だけを送ると、それ以外の欄（他の項目）の値が消えてしまう事故になるため、
 * 変更のたびに、この欄の中の全項目（[data-cart-attribute] すべて）をまとめて送信する。
 *
 * 【2026-09-21追加】お届け希望日の最短日：
 *   通常4日後〜／北海道・青森・秋田・岩手・熊本・宮崎・鹿児島・沖縄は5日後〜（社長指示）。
 *   カートページでは配送先住所を持たないため、お客様に都道府県を選んでもらい、それをもとに
 *   JS側でinput[type=date]のminを動的に書き換える（Liquidでの固定値ではなく実行時に計算）。
 *
 * 【2026-09-22追加】バブリングの問題：
 *   このコンポーネントは Dawn のカートフォーム（cart-drawer-items 等）の中に入れているため、
 *   熟旗のselectやラジオのchangeイベントが亲要素へバブルし、Dawn側の「数量変更」リスナーが
 *   それを拾って quantity に文字列を渡して /cart/change が400エラー（expected String to be a
 *   Integer: quantity）になり、「カートをアップデートするときにエラーが発生しました」が出ていた。
 *   対策として、このコンポーネント自体で change イベントを即時に stopPropagation し、
 *   親要素（Dawn側）へ届かないようにする。
 */
if (!customElements.get('cart-delivery-gift')) {
  const CDG_REMOTE_PREFECTURES = ['北海道', '青森県', '岩手県', '秋田県', '熊本県', '宮崎県', '鹿児島県', '沖縄県'];
  const CDG_NORMAL_MIN_DAYS = 4;
  const CDG_REMOTE_MIN_DAYS = 5;
  const CDG_MAX_DAYS = 30; // 2026-09-21: 2週間→1ヶ月に拡大（社長指示）

  const cdgFormatDate = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  };

  // 2026-09-21追加：7月以降の日付は選べないようにする（社長指示）。
  // 「直近の6月30日」を求め、すでに過ぎていれば来年の6月30日を使う。
  // 2026-10-06追加：「ギフト日付指定可」タグ（ギフト）の商品がカートにあるときは、お届け希望日を「12/1〜翌年6/10」に限定する（社長指示）。
  // 6/10を過ぎたら翌年の6/10まで。開始日は6/10の前年の12/1（すでに過ぎていれば注文日＋最短日数が優先される）。
  // Liquid側が日付欄に data-cdg-december-window を付ける。
  const cdgDecemberWindow = () => {
    const now = new Date();
    let endYear = now.getFullYear();
    if (now > new Date(endYear, 5, 10, 23, 59, 59)) endYear += 1;
    return { start: new Date(endYear - 1, 11, 1), end: new Date(endYear, 5, 10) };
  };

  // 2026-10-06追加：「12月10日以降日付指定可」タグ（通常のミニトマト）の商品がカートにあるときは、
  // お届け希望日を「12/10〜翌年6/20」に限定する（社長指示）。ギフト（ギフト日付指定可）が一緒にあるときはギフトの範囲を優先する。
  // 6/20を過ぎたら翌年の6/20まで。開始日は6/20の前年の12/10（すでに過ぎていれば注文日＋最短日数が優先される）。
  const cdgRegularWindow = () => {
    const now = new Date();
    let endYear = now.getFullYear();
    if (now > new Date(endYear, 5, 20, 23, 59, 59)) endYear += 1;
    return { start: new Date(endYear - 1, 11, 10), end: new Date(endYear, 5, 20) };
  };

  const cdgJuneCutoff = () => {
    const now = new Date();
    let cutoff = new Date(now.getFullYear(), 5, 30); // 月は0始まりなので5=6月
    if (now > cutoff) {
      cutoff = new Date(now.getFullYear() + 1, 5, 30);
    }
    return cutoff;
  };

  customElements.define(
    'cart-delivery-gift',
    class CartDeliveryGift extends HTMLElement {
      constructor() {
        super();

        // 2026-09-22追加：Dawn側の数量変更リスナーへイベントが伝播しないよう、
        // このコンポーネント自身で change イベントを即時に止める（デバウンスより前に必要）。
        this.addEventListener('change', (event) => {
          event.stopPropagation();
        });

        const handler = (typeof debounce === 'function')
          ? debounce(this.onChange.bind(this), (typeof ON_CHANGE_DEBOUNCE_TIMER !== 'undefined') ? ON_CHANGE_DEBOUNCE_TIMER : 300)
          : this.onChange.bind(this);

        this.addEventListener('change', handler);

        this._initDeliveryModeToggle();
        this._initGiftNameToggle();
      }

      onChange(event) {
        const target = event.target;
        if (!target || !target.dataset || !target.dataset.cartAttribute) return;
        this.saveAttributes();
      }

      async saveAttributes() {
        const updateUrl = (typeof routes !== 'undefined' && routes.cart_update_url)
          ? routes.cart_update_url
          : '/cart/update.js';

        // 丸ごと置き換わる仕様のため、まず今のカート属性を取得してから、
        // この欄の入力だけを上書きし、全体をまとめて送り直す。
        // （他のアプリ等が別のカート属性を使っていても消さないため）
        let attributes = {};
        try {
          const currentCart = await fetch('/cart.js').then((r) => r.json());
          attributes = Object.assign({}, currentCart.attributes || {});
        } catch (error) {
          console.error('cart-delivery-gift: 既存のカート属性の取得に失敗しました', error);
        }

        this.querySelectorAll('[data-cart-attribute]').forEach((el) => {
          const key = el.dataset.cartAttribute;
          attributes[key] = el.type === 'checkbox' ? (el.checked ? el.value : '') : el.value;
        });

        const body = JSON.stringify({ attributes: attributes });

        const fetchOptions = (typeof fetchConfig === 'function')
          ? Object.assign({}, fetchConfig(), { body: body })
          : {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: body,
            };

        fetch(updateUrl, fetchOptions).catch((error) => {
          console.error('cart-delivery-gift: 属性の保存に失敗しました', error);
        });
      }

      // 「日付指定なし／日付を指定する」の切り替えと、
      // 都道府県に応じたお届け希望日の最短日（min）の動的な書き換え。
      _initDeliveryModeToggle() {
        const modeRadios = this.querySelectorAll('[data-cdg-mode-radio]');
        const specifyFields = this.querySelector('[data-cdg-specify-fields]');
        const dateInput = this.querySelector('[data-cdg-date]');
        const timeSelect = this.querySelector('[data-cdg-time]');
        const prefectureSelect = this.querySelector('[data-cdg-prefecture]');

        if (!modeRadios.length || !specifyFields) return;

        const updateDateBounds = () => {
          if (!dateInput) return;
          const isRemote = !!(prefectureSelect && CDG_REMOTE_PREFECTURES.indexOf(prefectureSelect.value) !== -1);
          const minDays = isRemote ? CDG_REMOTE_MIN_DAYS : CDG_NORMAL_MIN_DAYS;
          const now = new Date();
          let minDate = new Date(now);
          minDate.setDate(minDate.getDate() + minDays);
          let maxDate = new Date(now);
          maxDate.setDate(maxDate.getDate() + CDG_MAX_DAYS);
          // 7月以降は選べないようにする：1ヶ月後の日付と6月30日、早い方を使う
          const juneCutoff = cdgJuneCutoff();
          if (juneCutoff < maxDate) maxDate = juneCutoff;
          // ギフト日付指定可（ギフト）の商品がある場合：最短日は「最短日数後」と12/1の遅い方、最長日は翌年6/10
          // 12月10日以降日付指定可（通常のミニトマト）の商品だけの場合：最短日は「最短日数後」と12/10の遅い方、最長日は6/20
          // 両方ある場合はギフトの範囲を優先する（Liquid側がギフトのときは data-cdg-december-window だけを付ける）
          const windowRule = dateInput.hasAttribute('data-cdg-december-window')
            ? cdgDecemberWindow()
            : (dateInput.hasAttribute('data-cdg-regular-window') ? cdgRegularWindow() : null);
          if (windowRule) {
            if (windowRule.start > minDate) minDate = windowRule.start;
            maxDate = windowRule.end;
          }
          dateInput.min = cdgFormatDate(minDate);
          dateInput.max = cdgFormatDate(maxDate);
          if (dateInput.value && (dateInput.value < dateInput.min || dateInput.value > dateInput.max)) {
            dateInput.value = '';
          }
        };

        const applyMode = (mode, options) => {
          const clear = options && options.clear;
          const isSpecify = mode === 'specify';
          specifyFields.hidden = !isSpecify;
          if (!isSpecify && clear) {
            if (dateInput) dateInput.value = '';
            if (timeSelect) timeSelect.value = '';
            if (prefectureSelect) prefectureSelect.value = '';
          }
        };

        modeRadios.forEach((radio) => {
          radio.addEventListener('change', () => {
            applyMode(radio.value, { clear: true });
            if (radio.value === 'specify') updateDateBounds();
            // モード切り替えのラジオ自体は data-cart-attribute を持たないため、
            // ここで明示的に保存（特に「指定なし」に切り替えたときの値クリアを反映するため）。
            this.saveAttributes();
          });
        });

        if (prefectureSelect) {
          prefectureSelect.addEventListener('change', updateDateBounds);
        }

        const checkedRadio = this.querySelector('[data-cdg-mode-radio]:checked');
        applyMode(checkedRadio ? checkedRadio.value : 'none');
        updateDateBounds();
      }

      // 2026-09-21追加：熨斗の種類を選んだときだけ「名入れする／しない」を聞き、
      // 「する」を選んだときだけお名前欄を出す。
      _initGiftNameToggle() {
        const noshiSelect = this.querySelector('[data-cdg-noshi-select]');
        const nameToggleWrapper = this.querySelector('[data-cdg-noshi-name-toggle-wrapper]');
        const nameModeRadios = this.querySelectorAll('[data-cdg-name-mode-radio]');
        const nameField = this.querySelector('[data-cdg-name-field]');
        const nameInput = this.querySelector('[data-cdg-name-input]');

        if (!noshiSelect || !nameToggleWrapper || !nameField) return;

        const applyNameMode = (mode, options) => {
          const clear = options && options.clear;
          const showName = mode === 'yes';
          nameField.hidden = !showName;
          if (!showName && clear && nameInput) nameInput.value = '';
        };

        noshiSelect.addEventListener('change', () => {
          const hasNoshi = noshiSelect.value !== '';
          nameToggleWrapper.hidden = !hasNoshi;
          if (!hasNoshi) {
            // 熨斗を「指定なし」に戻したら、名入れの選択も名前もクリア
            nameModeRadios.forEach((r) => {
              r.checked = r.value === 'no';
            });
            applyNameMode('no', { clear: true });
          } else {
            const checked = this.querySelector('[data-cdg-name-mode-radio]:checked');
            applyNameMode(checked ? checked.value : 'no');
          }
          this.saveAttributes();
        });

        nameModeRadios.forEach((radio) => {
          radio.addEventListener('change', () => {
            applyNameMode(radio.value, { clear: true });
            this.saveAttributes();
          });
        });

        // 初期表示
        const initialChecked = this.querySelector('[data-cdg-name-mode-radio]:checked');
        applyNameMode(initialChecked ? initialChecked.value : 'no');
      }
    }
  );
}
